import React from 'react';
import { NextSeo } from 'next-seo';
import Head from 'next/head';
import { getVideoPages, request as typedRequest } from 'lib/dato-request';
import { Layout } from 'components/Layout';
import EmbeddedVideoPlayer from '@/components/EmbeddedVideoPlayer/EmbeddedVideoPlayer';
import { HowItWorks } from 'components/HowItWorks';
import ConversionButtons from 'components/ConversionButtons/ConversionButtons';
import { VideoPageDocument } from '../../graphql/generated/datocms';

const VideoSection = ({ heading, videos, style }) => {
    return (
        <div className='video-section' style={style}>
            <div className='video-section-heading'>
                <h2>{heading}</h2>
            </div>

            {videos?.length && (
                <div className='videos-container'>
                    {videos?.map((video, index) => (
                        <React.Fragment key={index}>
                            <EmbeddedVideoPlayer {...video} />
                            {index !== videos.length - 1 && <hr />}
                        </React.Fragment>
                    ))}
                </div>
            )}

            <style jsx>
                {`
                    .video-section {
                        padding-top: 70px;
                        padding-bottom: 70px;

                        hr {
                            margin-top: 30px;
                            margin-bottom: 30px;
                        }

                        h2 {
                            text-align: center;
                            margin: 0 10px;
                            font-family: Inter, serif;
                            font-style: normal;
                            font-weight: 800;
                            font-size: 48px;
                            line-height: 55px;
                            text-align: center;
                            //color: #4F4F4F;

                            // TODO: gradient text
                            background: -webkit-linear-gradient(#e637a8, #e68037);
                            -webkit-background-clip: text;
                            -webkit-text-fill-color: transparent;
                        }

                        .videos-container {
                            text-align: left;
                            margin-top: 70px;
                            margin-left: auto;
                            margin-right: auto;
                            width: 1000px;
                            min-height: 200px;

                            @media (max-width: 1040px) {
                                width: calc(100% - 40px);
                            }
                        }
                    }
                `}
            </style>
        </div>
    );
};

const VideoPage = ({ data }) => {
    const { videoPage } = data;
    const { seo, components } = videoPage;
    const showDemoSignup = videoPage.internalName === 'HCPS Training Page';
    const customCSS = '.video-page-header img { margin: auto; width: 100%; height: auto; max-width: 800px; }' + '.video-page-header h3 { color: #d87264; font-size: 33px; }';
    return (
        <Layout showClassCodeInput={false} showLoginAndSignup={false}>
            <NextSeo
                title={seo?.title ?? videoPage.heading ?? videoPage.slug}
                description={seo?.description}
            />
            <Head>
                <meta name='keywords' content={videoPage.keywords} />
            </Head>
            <div id='video-page'>
                {videoPage.heading && (
                    <div className='video-page-header'>
                        {videoPage.heading && (
                            <h1 className={videoPage.videoSections?.length ? 'video-sections-heading' : 'video-page-heading'}>{videoPage.heading}</h1>
                        )}
                        {videoPage.subheading && <p>{videoPage.subheading}</p>}

                        {videoPage.subheading2 && (
                            <div className=' paragraph subtext'>
                                <div
                                    dangerouslySetInnerHTML={{ __html: `<style>${customCSS}</style>${videoPage.subheading2}` }} />
                            </div>
                        )}
                    </div>
                )}

                {videoPage.videos?.length > 0 && (
                    <div className='videos-container'>
                        {videoPage.videos?.map((video, index) => (
                            <React.Fragment key={index}>
                                <EmbeddedVideoPlayer {...video} />
                                {index !== videoPage.videos.length - 1 && <hr />}
                            </React.Fragment>
                        ))}
                    </div>
                )}

                {videoPage.vimeoVideos?.length > 0 && (
                    <div className='videos-container'>
                        {videoPage.vimeoVideos?.map((video, index) => (
                            <React.Fragment key={index}>
                                <EmbeddedVideoPlayer {...video} />
                                {index !== videoPage.vimeoVideos.length - 1 && <hr />}
                            </React.Fragment>
                        ))}
                    </div>
                )}

                {videoPage.videoSections?.length > 0 && (
                    <div className='video-sections-container'>
                        {videoPage.videoSections.map((section, i) => (
                            <VideoSection key={i} {...section} style={{ background: i % 2 ? '#f9f9f9' : '#ffffff' }} />
                        ))}
                    </div>
                )}

                {/*
                { showDemoSignup && <ConversionPanel3
                    heading={"Want to See Muzology in Action?"}
                    subhead={"We’d love to show you the platform."}
                    ctalabel={"SCHEDULE A DEMO"}
                    ctalink={'/demo'}
                /> }
                */}
                <style jsx>{`
                    #video-page {
                        margin: 100px auto;

                        .video-page-header {
                            padding-top: 40px;
                            margin: 0 auto;
                            max-width: 1000px;
                            text-align: center;

                            @media (max-width: 1000px) {
                                width: 100%;
                                max-width: 100%;
                                padding: 0 20px;
                            }


                            //background-repeat: no-repeat;
                            //background-position: center;
                            //background-size: contain;
                            //background-image: url("/assets/backgrounds/videos_hero_background.png");

                            .subtext {
                                //padding: 0 200px;
                                margin-left: auto;
                                margin-right: auto;
                                text-align: left;
                                //white-space: pre-line;
                                width: 1300px;

                                strong {
                                    font-weight: 900;
                                }

                                @media (max-width: 1330px) {
                                    //padding: 0 20px;
                                    width: 90%;
                                }

                                //@media (max-width: 830px) {
                                //    padding: 0 60px;
                                //}
                                //
                                //@media (max-width: 720px) {
                                //    padding: 0 20px;
                                //}
                            }
                        }

                        h1 {
                            margin: 0 10px;
                            font-family: Inter, serif;
                            font-style: normal;
                            font-weight: 800;
                            font-size: 48px;
                            line-height: 55px;
                            text-align: center;

                            .video-sections-heading {
                                background: #121651;
                            }

                            .video-page-heading {
                                //color: #4F4F4F;

                                // TODO: gradient text
                                background: -webkit-linear-gradient(#e637a8, #e68037);
                                -webkit-background-clip: text;
                                -webkit-text-fill-color: transparent;
                            }
                        }

                        .paragraph {
                            margin: 20px 10px;
                            font-family: Inter, serif;
                            font-style: normal;
                            font-weight: 500;
                            //line-height: 25px;
                            font-size: 22px;
                            line-height: normal;
                            text-align: center;
                            color: #4f4f4f;
                        }

                        .videos-container {
                            margin-top: 70px;
                            margin-left: auto;
                            margin-right: auto;
                            width: 1000px;

                            @media (max-width: 1040px) {
                                width: calc(100% - 40px);
                            }
                        }

                        hr {
                            width: 870px;
                            max-width: 100%;
                            padding-left: 20px;
                            padding-right: 20px;
                            border-color: transparent;
                            border-top: 2px solid #e8e8e8;
                            margin-top: 56px;
                            margin-bottom: 56px;
                        }
                    }
                `}</style>
            </div>
            {components.length > 0 && (<>
                <HowItWorks
                    style={{ paddingTop: 60 }}
                    heading={components[0].heading}
                    subhead={components[0].subhead}
                    img={components[0].featuredImage}
                    richText={components[0].richText}
                    flip={components[0].flipSides}
                    ctaButton={false}
                    videoLink={null}
                />
                <ConversionButtons />
            </>)}
        </Layout>
    );
};

export async function getStaticPaths() {
    const data = await getVideoPages();
    const paths = data.allVideoPages.map((post) => ({
        params: {
            slug: post.slug
        }
    }));
    return { paths, fallback: false };
}

export async function getStaticProps({ params }) {
    const { slug } = params;
    const data = await typedRequest(VideoPageDocument, { slug });
    return { props: { data } };
}

export default VideoPage;
